export function transformFoodAndBeverageCardToBrandCard(card) {
    return {
        name: card.title,
        image: card.image,
        logo: card.logo,
        description: card.text,
        categories: card.categories,
        path: card.path,
        componentID: card.componentID,
        contentTypeId: card.contentTypeId,
    };
}
